import { ICityClimateData } from '../energy.models';

/**
 * List of cities with their normal year temperature (median temperature).
 * DOT: For 10 days time constant
 * Source: https://www.lth.se/fileadmin/ees/Publikationer/2006/5091.pdf (p.26)
 * DOT (DVUT): https://www.boverket.se/sv/om-boverket/publicerat-av-boverket/oppna-data/dimensionerande-vinterutetemperatur-dvut-1981-2010/
 *
 * Cooling hours: Number of hours per year when cooling is needed for office buildings.
 * Based on:
 * - Temperature exceeding 22°C (Arbetsmiljöverket's recommendations)
 * - Office hours (typically 07-18, weekdays)
 * - Heat exchanger cooling used when:
 *   1. Outdoor temperature is higher than indoor temperature
 *   2. Indoor temperature exceeds 22°C
 *   3. Building is occupied
 *
 * Note: Outside office hours, buildings typically use:
 * - Minimal or no active cooling
 * - Reduced ventilation
 * - Night cooling strategies when needed
 */
export const cityClimateDataList: ICityClimateData[] = [
  {
    city: 'Malmö',
    lat: 55.61,
    lng: 13.07,
    temp: 8,
    sunHours: 1700,
    dot: -7.4,
    fGeo: 0.8,
    solarInsolation: 950,
    coolingHours: 500, // Adjusted for office hours (07-18)
  },
  {
    city: 'Växjö',
    lat: 56.84,
    lng: 14.82,
    temp: 6.5,
    sunHours: 1650,
    dot: -11.5,
    fGeo: 1, // See "Kronoberg"
    solarInsolation: 895,
    coolingHours: 425, // Adjusted for office hours
  },
  {
    city: 'Kalmar',
    lat: 56.73,
    lng: 16.29,
    temp: 7,
    sunHours: 1800,
    dot: -9.5,
    fGeo: 0.9,
    coolingHours: 400,
  },
  {
    city: 'Göteborg',
    lat: 57.72,
    lng: 11.99,
    temp: 7.9,
    sunHours: 1600,
    dot: -10,
    fGeo: 0.9,
    solarInsolation: 958,
    coolingHours: 425,
  },
  {
    city: 'Karlstad',
    lat: 59.38,
    lng: 13.45,
    temp: 5.9,
    sunHours: 1550,
    dot: -15.5,
    fGeo: 1.1,
    solarInsolation: 1086,
    coolingHours: 350,
  },
  {
    city: 'Örebro',
    lat: 59.28,
    lng: 15.16,
    temp: 5.9,
    sunHours: 1600,
    dot: -13.9,
    fGeo: 1,
    coolingHours: 350,
  },
  {
    city: 'Stockholm',
    lat: 59.34,
    lng: 18.05,
    temp: 6.6,
    sunHours: 1800,
    dot: -11.9,
    fGeo: 1,
    solarInsolation: 1042,
    coolingHours: 375,
  },
  {
    city: 'Östersund',
    lat: 63.17,
    lng: 14.68,
    temp: 2.7,
    sunHours: 1500,
    dot: -18.3,
    fGeo: 1.4,
    solarInsolation: 915,
    coolingHours: 250,
  },
  {
    city: 'Umeå',
    lat: 63.83,
    lng: 20.29,
    temp: 3.4,
    sunHours: 1600,
    dot: -19.5,
    fGeo: 1.3,
    solarInsolation: 1047,
    coolingHours: 275,
  },
  {
    city: 'Luleå',
    lat: 65.54,
    lng: 22.12,
    temp: 3,
    sunHours: 1650,
    dot: -22.8,
    fGeo: 1.5,
    solarInsolation: 1035,
    coolingHours: 250,
  },
  {
    city: 'Kiruna',
    lat: 67.83,
    lng: 20.34,
    temp: -1.2,
    sunHours: 1500,
    dot: -24.4,
    fGeo: 1.9,
    solarInsolation: 868,
    coolingHours: 175,
  },
];
